module.exports = __webpack_public_path__ + "img/111.199b003b.jpg";